import { render } from "./jobCard.vue?vue&type=template&id=71c5e990&scoped=true"
import script from "./jobCard.vue?vue&type=script&lang=js"
export * from "./jobCard.vue?vue&type=script&lang=js"

import "./jobCard.vue?vue&type=style&index=0&id=71c5e990&scoped=true&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c5e990"]])

export default __exports__